import {
    Crown,
    Zap,
    Headset,
    Wrench,
    Building, ThumbsUp, Award, CheckCircle
} from 'lucide-react';
import ChimneymainImg from '../img/hob-about-img-main.png';
import CTA from './Cta';
import HomeAboutUs from './Home/HomeAboutUs';
import CountUpCards from './CountUpCards';

function AboutUs() {
    return (
        <>
            <section className="hob-about-hero">
                <div className="hob-about-hero-content">
                    <h1 className="hob-about-title"> Welcome to My Therapy Practice</h1>
                    <p className="hob-about-subtitle">
                         Supporting mental well-being with compassion, evidence-based care, 
                        and a safe space for healing and growth.
                    </p>
                </div>
            </section>

            <HomeAboutUs />
            <CountUpCards />

            <CTA />
        </>
    );
}

export default AboutUs;
